export const ASYNC_STATES = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED',
};
